// frontend/src/utils/inTransitBreakdown.js
//
// What an Inventory row's In transit figure is made of: which rows HAVE a
// breakdown, and what counts as one. The Inventory grid renders it as a hover
// tooltip (components/grid/InTransitTooltip.jsx).
//
// The parts are stored columns written in the same save as the total
// (`purchase_orders.signals.update_inventory_in_transit`) and the database
// refuses a row where they do not add up to it
// (`inventory_in_transit_is_its_two_parts`), so the breakdown cannot drift
// from the number it explains. Nothing here recomputes the cell.

/**
 * The breakdown a row carries, or null when it carries no usable one.
 *
 * All three numbers come off the ROW, deliberately — the total is not a
 * parameter. An AG Grid tooltip component's `props.value` is NOT the cell
 * value: it is whatever `tooltipValueGetter` returned (AG Grid 36's cell
 * tooltip ctrl: `getTooltipValue` resolves the tooltip, and
 * `getAdditionalParams` carries `data` but no `value`). Ours returns `true`, so a total read from `props.value` is the
 * boolean. Reading the row leaves nothing for a caller to get wrong, and the
 * row carries `inventory_in_transit` on every shape the grid
 * draws: data rows, Shopify group headers, and the pinned totals row.
 */
export function inTransitBreakdown(row) {
  if (!row) return null;
  const terms = [
    row.inventory_in_transit,
    row.in_transit_purchase_orders,
    row.in_transit_transfers,
  ];
  // Every term is required, and required to be a NUMBER: the API serializes
  // all three as integers Coalesced to 0, so a null or an absent one means
  // the row shape changed. `Number(null)` is 0, which would read a broken
  // payload as "nothing from that source" and print a breakdown that adds up
  // while being wrong — the one outcome worse than no tooltip.
  if (terms.some((n) => typeof n !== 'number' || !Number.isFinite(n))) return null;
  const [inTransit, purchaseOrders, transfers] = terms;
  // Nothing on the water, nothing to explain.
  if (inTransit === 0) return null;
  return { total: inTransit, purchaseOrders, transfers };
}
